<template>
  <div>
    <div v-if="loading_page === true">
      <v-sheet
        :color="`grey ${theme.isDark ? 'darken-2' : 'lighten-4'}`"
        class="pa-3"
      >
        <v-skeleton-loader type="article, actions"></v-skeleton-loader>
      </v-sheet>
    </div>
    <div class="mt-1" v-else>
      <v-row>
        <v-col xs="12" sm="12" md="6" lg="8" xl="8" cols="12">
          <div class="title_page ma-3">
            <h4 class="breadcrumb_title_page">โอนสินค้า</h4>
            <v-breadcrumbs :items="sub_menu">
              <template v-slot:divider>
                <v-icon>mdi-chevron-right</v-icon>
              </template>
            </v-breadcrumbs>
          </div>
        </v-col>
        <v-col xs="12" sm="12" md="3" lg="2" xl="2" cols="12">
          <div class="title_page my-3">
            <v-btn
              type="button"
              class="btn_detail_data"
              elevation="2"
              @click="link('/arin/pos/bestsellproduct/-')"
              large
              >ดูรายการขายดีของสาขา</v-btn
            >
          </div>
        </v-col>
        <v-col xs="12" sm="12" md="3" lg="2" xl="2" cols="12">
          <!-- ต้องทำการ if else ดักต่อเมื่อสร้างรอบนับแล้ว -->
          <div class="title_page my-3">
            <v-btn
              type="button"
              class="btn_add_data"
              elevation="2"
              @click="link('/arin/pos/transfergoodsadd')"
              large
              >สร้างรอบโอนสินค้า</v-btn
            >
          </div>
        </v-col>
      </v-row>
      <div class="mt-1">
        <v-card elevation="3" class="pa-4" style="border-radius: 15px">
          <section class="d-flex justify-space-between">
            <v-row>
              <v-col
                xs="6"
                sm="6"
                md="9"
                lg="9"
                xl="9"
                cols="6"
                class="content-header-title"
              >
                <div class="">ประวัติการโอนสินค้า</div>
              </v-col>
              <v-col xs="6" sm="6" md="3" lg="3" xl="3" cols="6">
                <div class="mt-1">
                  <v-text-field
                    color="#D6BFAF"
                    class="input-radius"
                    append-icon="mdi-magnify"
                    hide-details="auto"
                    required
                    v-model="search"
                    placeholder="ค้นหา..."
                    outlined
                    dense
                  ></v-text-field>
                </div>
              </v-col>
            </v-row>
          </section>

          <section class="pa-3">
            <v-data-table
              :headers="headers"
              :items="data_list"
              :search="search"
              :footer-props="footer_Props"
              mobile-breakpoint="0"
            >
              <template v-slot:item="dataDetail">
                <tr>
                  <td>
                    <div class="font-16">
                      {{ formatDate(dataDetail.item.created_at) }}
                    </div>
                  </td>
                  <td>
                    <div class="font-16">
                      {{ dataDetail.item.customer_code }}
                    </div>
                  </td>
                  <td>
                    <div class="font-16">
                      {{ dataDetail.item.history_store_name }}
                    </div>
                  </td>
                  <td>
                    <div
                      v-if="dataDetail.item.history_transfer_status == 1"
                      class="font-16"
                      style="color: #fea06c"
                    >
                      รอยินยันสินค้า
                    </div>
                    <div
                      v-if="dataDetail.item.history_transfer_status == 2"
                      class="font-16"
                      style="color: #88b358"
                    >
                      ยืนยันสินค้า
                    </div>
                    <div
                      v-if="dataDetail.item.history_transfer_status == 3"
                      class="font-16"
                      style="color: #f28080"
                    >
                      ยกเลิก
                    </div>
                  </td>
                  <td>
                    <div class="font-16">{{ dataDetail.item.store_name }}</div>
                  </td>
                  <td>
                    <div class="d-flex">
                      <v-btn
                        elevation="4"
                        class="ma-2"
                        outlined
                        color="#8EBBDC"
                        height="45"
                        small
                        title="ดูรายละเอียด"
                        style="border-radius: 10px"
                        @click="
                          link(
                            '/arin/pos/transfergoodsdetail/' +
                              dataDetail.item.history_transfer_id
                          )
                        "
                      >
                        <v-icon>mdi-magnify</v-icon>
                      </v-btn>
                      <v-btn
                        elevation="4"
                        class="ma-2"
                        @click="
                          link(
                            '/arin/pos/transfergoodsedit/' +
                              dataDetail.item.history_transfer_id
                          )
                        "
                        outlined
                        :color="
                          dataDetail.item.history_transfer_status == 1
                            ? '#FEA06C'
                            : ''
                        "
                        height="45"
                        small
                        title="แก้ไขรายละเอียด"
                        style="border-radius: 10px"
                        :disabled="dataDetail.item.history_transfer_status != 1"
                      >
                        <v-icon>mdi-pencil</v-icon>
                      </v-btn>
                      <v-btn
                        type="button"
                        elevation="4"
                        class="ma-2"
                        @click="
                          delete_transfer(dataDetail.item.history_transfer_id)
                        "
                        outlined
                        height="45"
                        small
                        :color="
                          dataDetail.item.history_transfer_status == 1
                            ? '#F28080'
                            : ''
                        "
                        title="ลบข้อมูล"
                        style="border-radius: 10px"
                        :disabled="dataDetail.item.history_transfer_status != 1"
                      >
                        <v-icon>mdi-trash-can-outline</v-icon>
                      </v-btn>
                    </div>
                  </td>
                </tr>
              </template>
            </v-data-table>
          </section>
        </v-card>
      </div>
    </div>
  </div>
</template>

<script>
import cancel_order from "@/assets/checked_refund.png";
import { minDate } from "@/js/handler";
import { HTTP_ARIN } from "@/axios_arin";
import Swal from "sweetalert2";
export default {
  inject: {
    theme: {
      default: {
        isDark: false,
      },
    },
  },
  name: "Admin_list",
  data() {
    return {
      loading_page: false,
      img_cancel_order: cancel_order,
      dialog_cancel_order: false,
      data_cancel: "",
      page: 1,
      size: 1000,
      count_page: 1,
      page_number: 1,
      search: "",
      footer_Props: {
        "items-per-page-text": "รายการต่อหน้า",
      },
      headers: [
        {
          text: "วันที่",
          value: "created_at",
          fixed: true,
          width: "150px",
        },
        {
          text: "รหัสสาขาที่โอนสินค้า",
          value: "customer_code",
          fixed: true,
          width: "150px",
        },
        {
          text: "ชื่อสาขา",
          value: "store_name",
          fixed: true,
          width: "200px",
        },
        {
          text: "สถานะ",
          value: "status",
          fixed: true,
          width: "120px",
        },
        {
          text: "ผู้ดำเนินการ",
          value: "create_by",
          fixed: true,
          width: "180px",
        },
        {
          text: "จัดการ",
          value: "",
          fixed: true,
          sortable: false,
          width: "200px",
        },
      ],
      dataList: [],
      counting_check: null,
      sub_menu: [
        {
          text: "ระบบ POS",
          disabled: false,
        },
        {
          text: "คลังสินค้า",
          disabled: false,
        },
        {
          text: "โอนสินค้า",
          disabled: false,
          href: "#",
        },
      ],
      menu_date: false,
      date: new Date(Date.now() - new Date().getTimezoneOffset() * 60000)
        .toISOString()
        .substr(0, 10),
      dateEN: "",
      start_date: this.min_date(),
    };
  },
  methods: {
    dialog_cancel_order_dialog(id) {
      this.dialog_cancel_order = true;
      this.data_cancel = id;
    },

    link(link) {
      window.location.href = link;
    },

    detail_employee() {
      this.$router.push("/arin/adminlist/detailemployee");
    },
    // async page(type) {
    //   // this.loading_page = true
    //   this.page_number = type
    // },
    min_date: function () {
      return minDate();
    },
    async selectDate() {
      this.$refs.menu_date.save(this.date);
      this.menu_date = false;
    },
    diffDateTH(value) {
      const diff = value.split("-");
      const day = diff[2];
      const month = diff[1];
      const year = parseInt(diff[0]) + 543;
      const final_date = day + "/" + month + "/" + year;
      return (this.date = final_date);
    },
    diffDateEN() {
      const diff = this.date.split("-");
      const year = parseInt(diff[2]) - 543;
      const month = diff[1];
      const day = diff[0];
      return year + "-" + month + "-" + day;
    },
    formatDate(dateString) {
      // แปลงวันที่เป็นรูปแบบที่ต้องการ
      const date = new Date(dateString);
      const day = String(date.getDate()).padStart(2, "0");
      const month = String(date.getMonth() + 1).padStart(2, "0");
      const year = date.getFullYear();
      return `${month}/${day}/${year}`;
    },
    getTransferAll() {
      this.loading_page = true;
      this.data_list = [];
      const data = {
        page: this.page,
        size: this.size,
      };
      const config = {
        headers: {
          Authorization: `Bearer ${this.$store.state.store_arin.access_token}`,
        },
      };
      HTTP_ARIN.post("/warehouse/transferall", data, config).then((res) => {
        if (res.data.successful === true) {
          this.loading_page = false;
          this.count_page = res.data.count_page;
          this.data_list = res.data.TransferAll.filter(el=>el.id == this.$store.state.store_arin.user_data.store_id);
        }
      });
    },
    delete_transfer(id) {
      Swal.fire({
        title: "ยืนยันลบการโอนสินค้าหรือไม่ ?",
        icon: "error",
        showCancelButton: true,
        confirmButtonText: "ยืนยัน",
        cancelButtonText: "ยกเลิก",
      }).then((result) => {
        if (result.isConfirmed) {
          const config = {
            headers: {
              Authorization: `Bearer ${this.$store.state.store_arin.access_token}`,
            },
          };
          HTTP_ARIN.post("/warehouse/deletetransferproduct/" + id, null, config).then(
            (res) => {
              if (res.data.successful === true) {
                Swal.fire({
                  title: "ลบสำเร็จ",
                  text: "เพิ่มข้อมูลเรียบร้อย",
                  icon: "success",
                  timer: 1500,
                  timerProgressBar: true,
                  showConfirmButton: false,
                });
                this.data_list.find((el) => {
                  if (el.history_transfer_id == id) {
                    el.history_transfer_status = 3;
                  }
                });
              }
            }
          );
        }
      });
    },
  },
  created() {
    const diff = this.date.split("-");
    const day = diff[2];
    const month = diff[1];
    const year = parseInt(diff[0]) + 543;
    const final_date = day + "/" + month + "/" + year;
    return (this.date = final_date);
  },
  mounted() {
    this.getTransferAll();
  },
};
</script>

<style scoped>
.v-timeline::before {
  top: 55px;
  height: calc(100% - 80px);
}

.theme--light.v-timeline:before {
  background-color: #d6bfaf;
  width: 4px;
}

/* .header-content {
  margin-left: -45px;
  background: #f1e9e3;
  border: 1px solid #f1e9e3;
  box-shadow: 0 4px 4px rgba(0, 0, 0, 0.25);
  border-radius: 0 30px 30px 0;
} */
.content-font {
  color: #616a6b;
  font-weight: 500;
  font-size: 16px;
}

.logo_timeline {
  width: 25px;
  height: 25px;
}

.logo_timeline > img {
  max-width: 25px;
}

.text_title {
  color: #616a6b;
  font-weight: bold;
  font-size: 16px;
}

.grid_half {
  display: grid;
  grid-template-columns: 45% 55%;
}

.radio_half {
  display: grid;
  grid-template-columns: 50%;
}

.v-otp-input .v-input {
  padding: 10px !important;
}

.input-radius {
  border-radius: 10px;
}

.grid_radio {
  display: flex;
  justify-content: space-between;
}

.btn_width {
  width: 50%;
}

.image_half {
  display: grid;
  grid-template-columns: 40% 60%;
}

.input_half {
  display: grid;
  grid-template-columns: 50% 50%;
}

.mobile_btn {
  width: 15%;
}

.file_input_style {
  position: absolute;
  top: -25px;
  left: 265px;
  right: 0;
  bottom: 0;
}

.preview {
  border-radius: 10px;
  display: inline-block;
}

.logo_admin {
  width: 80px;
  height: 80px;
}

.logo_admin > img {
  max-width: 80px;
}

.btn_width {
  width: 50%;
}

.input-radius {
  border-radius: 10px;
}

.text_header {
  color: #616a6b;
  font-weight: bold;
  font-size: 20px;
}

.text_header_title {
  color: #616a6b;
  font-weight: bold;
  font-size: 22px;
}

/* ขนาด font 16 */
.font-16 {
  font-size: 16px !important;
}

.text_title {
  color: #616a6b;
  font-weight: bold;
  font-size: 16px;
}

.input_two_four {
  display: grid;
  grid-template-columns: 20% 40%;
}

.input_four_six {
  display: grid;
  grid-template-columns: 40% 60%;
}

.content-header-title {
  color: #616a6b;
  font-weight: 1000;
  font-size: 20px;
  display: flex;
  align-items: center;
}

.btn_detail_data {
  font-size: 16px;
  color: #fff;
  background: linear-gradient(90deg, #0f71b9 0%, rgba(136, 179, 88, 0) 100%),
    #8ebbdc !important;
  border-radius: 10px;
  width: 100%;
}

.btn_add_data {
  font-size: 16px;
  color: #fff;
  background: linear-gradient(90deg, #659264 0%, rgba(136, 179, 88, 0) 100%),
    #88b358 !important;
  border-radius: 10px;
  width: 100% !important;
}

.btn_add_data_pop {
  font-size: 16px;
  color: #fff;
  background: linear-gradient(90deg, #659264 0%, rgba(136, 179, 88, 0) 100%),
    #88b358 !important;
  border-radius: 10px;
  width: 135px !important;
}
</style>
